import React from 'react'
import { Carousel } from 'antd';
import { PORT_SERVER } from '../../Config';

export const staticPathForBuildModeWithURL = (originURL) => {
    if (!originURL || (typeof originURL !== 'string') || originURL.length < 1) {
        // console.log('invalid URL:', originURL);
        return;
    }

    let fullURL = originURL;

    if (originURL.indexOf('http') === -1){
        if (process.env.NODE_ENV === "development") {
            fullURL = `http://localhost:${PORT_SERVER}/${originURL}`;
        }
        else if (!originURL.startsWith('/')) {
            //check imagePath relative to absolute for client pages
            fullURL = '/' + originURL;
        }
    }
    return fullURL;
}

function ImageSlider(props) {
    return (
        <div>
            <Carousel autoplay>
                {props.images.map((imageURL, index) => {
                    return <div key={index}>
                        <img style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                            src={staticPathForBuildModeWithURL(imageURL)} alt="productImage" />
                    </div>
                })}
            </Carousel>
        </div>
    )
}

export default ImageSlider
